import $ from 'jquery';

$(function() {

    let playVideoDivCount = $('.play-video').length;
    let ytApiPlayerCount = $('.ytApiPlayer').length;

    //console.log('playVideoDivCount: ' + playVideoDivCount)
    //console.log('ytApiPlayerCount: ' + ytApiPlayerCount)

    if ((playVideoDivCount + ytApiPlayerCount) > 0) {
        loadYouTubeAPI()
            .then(YT => {
                // Create your player here
                //console.log('YouTube API loaded successfully');
                initCarouselVideos();
            })
            .catch(error => {
                console.error('Failed to load YouTube API:', error);
            });
    }

});

function loadYouTubeAPI() {
    return new Promise((resolve, reject) => {
        if (typeof YT !== 'undefined' && YT.loaded) {
            resolve(YT);
        } else {
            onYouTubeIframeAPIReady = () => resolve(YT);
            // Load the player_api
            const playerScript = document.createElement('script');
            playerScript.src = 'https://www.youtube.com/player_api';
            playerScript.onerror = reject;
            document.body.appendChild(playerScript);
            // Load the iframe_api
            const iframeScript = document.createElement('script');
            iframeScript.src = 'https://www.youtube.com/iframe_api';
            iframeScript.onerror = reject;
            document.body.appendChild(iframeScript);
        }
    });
}

window.carouselVideos = [];

function initCarouselVideos() {

    // Make a global array of the iframes on the page
    $('.ytApiPlayer').each(function() {
        let id = $(this).find('iframe').attr('id');
        if (id) {
            window.carouselVideos[id] = new YT.Player(id);
        }
    });

}
